import { HTMLAttributes, useCallback } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { Button } from '../../../../../../common/button-new';
import { Modal } from '../../../../../../common';
import { ControlVisitModalViewProps } from './control-visit-modal.models';
import { useStyles } from './control-visit-modal.styles';
import { convertDateToUIString } from '../../../../../../../utils/date/convert-date-to-string';
import controlVisitBanner from '../../../../../../../assets/images/cv/control-visit-banner.png';
import { cx } from '../../../../../../../utils';

export const ControlVisitModal = ({
  cvBonusPoints, cvBonusEndDate, onCvDetailsClick, onClose, onAppointmentClick, ...props
}: ControlVisitModalViewProps): JSX.Element => {
  const intl = useIntl();
  const classes = useStyles();

  const formattedDate = convertDateToUIString(cvBonusEndDate) ?? '';
  const points = cvBonusPoints ?? '';

  const handleAppointmentClick = async (): Promise<void> => {
    await onClose?.();
    onAppointmentClick();
  };

  const handleCvDetailsClick = useCallback(async (): Promise<void> => {
    await onClose?.();
    onCvDetailsClick();
  }, [onCvDetailsClick, onClose]);

  return (
    <Modal
      {...props}
      onClose={onClose}
      PaperProps={{
        'data-testid': 'control-visit-modal',
      } as HTMLAttributes<HTMLDivElement>}
      propsPaperStyles={classes.paper}
      propsContentStyles={classes.content}
      content={(
        <>
          <h2 className={cx('title-medium', classes.title, 'title-bold')}>
            {intl.formatMessage(
              { id: 'controlVisit.notification.title' },
              { date: formattedDate, points, noBreak: <>&nbsp;</> },
            )}
          </h2>
          <img data-testid="control-visit-image" src={controlVisitBanner} alt="" className={classes.image} />
          <p className={classes.description} data-testid="control-visit-description">
            <FormattedMessage id="controlVisit.notification.description" />
          </p>
          <div className={classes.actions}>
            <Button
              style="cv"
              testId="control-visit-appointment-button"
              onClick={handleAppointmentClick}
              rootClasses={classes.button}
            >
              <FormattedMessage id="common.cv.action" values={{ noBreak: <>&nbsp;</> }} />
            </Button>
            <Button
              style="cv-outlined"
              testId="control-visit-details-button"
              onClick={handleCvDetailsClick}
              rootClasses={classes.button}
            >
              <FormattedMessage id="controlVisit.notification.detailsButton" />
            </Button>
          </div>
          <p className={classes.disclaimer} data-testid="control-visit-disclaimer">
            <FormattedMessage id="controlVisit.notification.disclaimer" />
          </p>
        </>
      )}
    />
  );
};
